import ContentAdmin from './ContentAdmin';
import Carousel from './Carousel';
import slugify from '../helpers/formatters/slugify';

const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname === 'app.gcn.com';
const localhostAPIURLs = {
  geral: 'http://api.gcn.com:8000',
};

const apiToUse = isLocalhost ? localhostAPIURLs : ENV_URLS; // eslint-disable-line

/**
 * This is a Carousel that fetches data as the user access each slide
 */
export default class FetchCarousel {
  constructor(el, startSlide) {
    this.id = el.getAttribute('data-fetch-slider');
    this.contentAdm = new ContentAdmin();
    this.slider = document.querySelector(`[data-fetch-slider="${this.id}"]`);
    this.navigation = this.slider.querySelector(`[data-navigation="${this.id}"]`);
    this.prevBtn = this.navigation.querySelector('.carousel__nav-arrow--prev');
    this.nextBtn = this.navigation.querySelector('.carousel__nav-arrow--next');
    this.titleSlideList = undefined;
    this.contentSlideLists = undefined;

    this.startSlide = startSlide;
    this.phases = [];
    this.hasBeenFetched = [];
    this.currentSlide = undefined;
    this.lastSlide = undefined;
  }

  /**
   * Fetches the data of a championship phase
   * @param { Object } phase the phase object, with id and name
   * @param { Function } callback callback to be executed with the data received
   */
  fetchPhaseData(phase, callback) {
    fetch(`${apiToUse.geral}/api/volei/classificacao/etapa/${phase.id}/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      cache: 'no-cache',
    })
    .then(response => response.json())
    .then((json) => {
      this.hasBeenFetched[this.currentSlide] = true;
      if (callback) callback(json);
    })
    .catch(e => console.log(e));
  }

  fetchScheduleData(phase, callback) { //eslint-disable-line
    fetch(`${apiToUse.geral}/api/volei/rodadas/etapa/${phase.id}/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      cache: 'no-cache',
    })
    .then(response => response.json())
    .then((json) => {
      this.hasBeenFetched[this.currentSlide] = true;
      if (callback) callback(json);
    })
    .catch(e => console.log(e));
  }

  /**
   * Initializes the Carousel that fetches data:
   * 1 - fetches the phases data and constructs the slider structure
   * 2 - stores data and elements in the object
   * 3 - activates the initial slide defined by user
   * 4 - fetched the data of the respective phase and builds the corresponding html
   */
  init() {
    document.body.classList.add('loading');

    this.configurePhases(() => {
      this.titleSlideList = this.navigation.querySelector('.carousel__title-list').children; // store the slides for the titles
      this.contentSlideLists = this.slider.querySelector('.carousel__content-list').children; // store the slides for the slides

      const isFirstSlide = this.currentSlide === 0;
      const isLastSlide = this.currentSlide === this.lastSlide;
      if (isFirstSlide) this.prevBtn.classList.add('disabled');
      if (isLastSlide) this.nextBtn.classList.add('disabled');

      this.activateInitialSlide();
      const phase = this.phases[this.currentSlide];

      switch (phase.nome) {
        case 'Semifinais':
        case 'Finais':
          this.renderPlayoffs(phase);
          break;
        default:
          this.renderPointsTable(phase);
          break;
      }
    });

    this.prevBtn.addEventListener('click', this.prevSlide.bind(this));
    this.nextBtn.addEventListener('click', this.nextSlide.bind(this));
  }

  prevSlide() {
    const isFirstSlide = this.currentSlide === 0;

    if (!isFirstSlide) {
      const previousSlide = this.currentSlide;
      if (this.currentSlide === this.lastSlide) this.nextBtn.classList.remove('disabled');
      if (this.currentSlide === 1) this.prevBtn.classList.add('disabled');
      this.currentSlide -= 1;
      this.activateSlide(previousSlide);
    }
  }

  nextSlide() {
    const isLastSlide = this.currentSlide === this.lastSlide;

    if (!isLastSlide) {
      const previousSlide = this.currentSlide;
      // if the current slide is not the first one, activate prev btn
      if (this.currentSlide === 0) this.prevBtn.classList.remove('disabled');
      // if the future slide will be the last one, deactivate next btn
      if (this.currentSlide === (this.lastSlide - 1)) this.nextBtn.classList.add('disabled');
      this.currentSlide += 1;

      this.activateSlide(previousSlide);
    }
  }

  activateInitialSlide() {
    [].forEach.call(this.contentSlideLists, (slide, index) => {
      const contentSlide = slide;
      const titleSlide = this.titleSlideList[index];

      const direction = index > this.currentSlide ? 1 : -1;
      if (index === this.currentSlide) {
        titleSlide.setAttribute('data-slide', 'true');
        titleSlide.style.transform = 'translateX(0)';

        contentSlide.setAttribute('data-slide', 'true');
        contentSlide.style.transform = 'translateX(0)';
      } else {
        titleSlide.setAttribute('data-slide', 'false');
        titleSlide.style.transform = `translateX(${direction * 100}%)`;

        contentSlide.setAttribute('data-slide', 'false');
        contentSlide.style.transform = `translateX(${direction * 100}%)`;
      }
    });
  }

  activateSlide(previousSlide) {
    const phase = this.phases[this.currentSlide];

    if (!this.hasBeenFetched[this.currentSlide]) {
      document.body.classList.add('loading');

      switch (phase.nome) {
        case 'Semifinais':
        case 'Finais':
          this.renderPlayoffs(phase);
          this.changeSlide(previousSlide);
          break;
        default:
          this.renderPointsTable(phase);
          this.changeSlide(previousSlide);
          break;
      }
    } else {
      this.changeSlide(previousSlide);
    }
  }

  changeSlide(previousSlide) {
    const direction = this.currentSlide > previousSlide ? -1 : 1;

    this.titleSlideList[previousSlide].setAttribute('data-slide', 'false');
    this.titleSlideList[previousSlide].style.transform = `translateX(${direction * 100}%)`;
    this.titleSlideList[this.currentSlide].setAttribute('data-slide', 'true');
    this.titleSlideList[this.currentSlide].style.transform = 'translateX(0)';

    this.contentSlideLists[previousSlide].setAttribute('data-slide', 'false');
    this.contentSlideLists[previousSlide].style.transform = `translateX(${direction * 100}%)`;
    this.contentSlideLists[this.currentSlide].setAttribute('data-slide', 'true');
    this.contentSlideLists[this.currentSlide].style.transform = 'translateX(0)';
  }

  /**
   * Fetches the phases data and builds the navigation element
   * @param {Function} callback callback to be executed
   */
  configurePhases(callback) {
    const slug = window.location.href.split('volei/tabela/')[1].split('/')[1].split('?')[0];

    fetch(`${apiToUse.geral}/api/volei/etapas/campeonato/${slug}/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      cache: 'no-cache',
    })
    .then(response => response.json())
      .then((json) => {
        const stagesTitleParent = document.querySelector('#slides-title-navigation');
        const stagesContentParent = document.querySelector('#slides-content');

        this.phases = json.etapas;
        const activePhase = json.etapa_ativa.id;
        this.lastSlide = this.phases.length - 1;

        this.phases.forEach((stg, index) => {
          this.hasBeenFetched.push(false);
          stagesTitleParent.insertAdjacentHTML('beforeend', `<li><h2 class="carousel__title">${stg.nome}</h2></li>`);
          stagesContentParent.insertAdjacentHTML('beforeend', `<li id="content-${slugify(stg.nome)}">`);

          if (stg.id === activePhase) {
            this.startSlide = index;
            this.currentSlide = index;
          }
        });

        if (callback) callback();
      });
  }

  renderPointsTable(phase) {
    this.fetchPhaseData(phase, (phaseData) => {
      this.fetchScheduleData(phase, (phaseSchedule) => {
        ContentAdmin.generateTable(`#content-${slugify(this.phases[this.currentSlide].nome)}`, phaseData);
        phaseSchedule.grupos.forEach((group) => {
          ContentAdmin.generateSchedule(`.${slugify(group.grupo.nome)} .tables`, group);
          const today = new Date();
          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);
          let initialRound = 0;
          let initialDiff = 99999999;
          const roundDates = group.rodadas.map((rodada, index) => { // eslint-disable-line
            let date = '';
            let timeDiff = '';
            let diff1 = '';
            let diff2 = '';
            if (rodada.data_inicio !== undefined && rodada.data_inicio !== null) {
              date = rodada.data_inicio.split('-');

              if (date[2].includes('T')) {
                date[2] = date[2].split('T')[0];
              }
              const date1 = new Date(date[0], (date[1] - 1), date[2]);

              timeDiff = Math.abs(date1.getTime() - today.getTime());
              diff1 = Math.ceil(timeDiff / (1000 * 3600 * 24));
            }
            if (rodada.data_fim !== undefined && rodada.data_fim !== null) {
              date = rodada.data_fim.split('-');
              if (date[2].includes('T')) {
                date[2] = date[2].split('T')[0];
              }
              const date2 = new Date(date[0], (date[1] - 1), date[2]);

              timeDiff = Math.abs(date2.getTime() - today.getTime());
              diff2 = Math.ceil(timeDiff / (1000 * 3600 * 24));
            }
            if (diff1 < initialDiff || diff2 < initialDiff) {
              initialRound = index;
              initialDiff = diff2 < diff1 ? diff2 : diff1;
            }
          });

          const sliders = this.contentSlideLists[this.currentSlide].querySelectorAll('[data-slider]');
          sliders.forEach(() => {
            const sl = new Carousel(sliders[sliders.length - 1], initialRound);
            sl.init();
          });
        });
        document.body.classList.remove('loading');
      });
    });
  }

  renderPlayoffs(phase) {
    this.fetchScheduleData(phase, (phaseSchedule) => {
      phaseSchedule.grupos.forEach((group) => {
        ContentAdmin.generatePlayOffs(`#content-${slugify(this.phases[this.currentSlide].nome)}`, group);
      });
      document.body.classList.remove('loading');
    });
  }
 }



// WEBPACK FOOTER //
// local_static/templates/volei/2018/assets/scripts/modules/FetchCarousel.js